import React from 'react'
import { Ban } from 'lucide-react'
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert'

class DoNotContactWarning extends React.Component {

  render() {
    if (!this.props.show) {
      return null
    }

    return (
      <Alert variant="warning" className={this.props.className}>
        <Ban />
        <AlertTitle>Do not contact</AlertTitle>
        <AlertDescription>This {this.props.contact || 'customer'} is marked as do not contact — sending is blocked.</AlertDescription>
      </Alert>
    )
  }
}

export default DoNotContactWarning
